class Lightbox {
    constructor(imgList) {
        this.imgList = imgList;
        this.imgIndex = 0;
        this.element = this.generateElement();
        this.imgCache = {};
        this.bindListeners();
    }

    bindListeners() {
        let el = this.getElement();
        el.querySelector('.mo-lb-prev').addEventListener('click', this.previous.bind(this));
        el.querySelector('.mo-lb-next').addEventListener('click', this.next.bind(this));
        el.querySelector('.mo-lb-close').addEventListener('click', this.close.bind(this));
    }

    generateElement() {
        let el = document.createElement('div');
        el.classList.add('mo-lb');
        let html = '';
        html += '<button class="mo-lb-close" type="button"><span>Close</span></button>';
        html += '<div class="mo-lb-screen">';
        html += '<i></i>';
        html += '</div>';
        html += '<div class="mo-lb-controls">';
        html += '<div class="mo-lb-prev">';
        html += '<button title="Previous image" type="button"><span>Previous</span></button>';
        html += '</div>';
        html += '<div class="mo-lb-title">';
        html += '<h2>Loading...</h2>';
        html += '</div>';
        html += '<div class="mo-lb-next">';
        html += '<button title="Next image" type="button"><span>Next</span></button>';
        html += '</div>';
        html += '</div>';
        el.innerHTML = html;
        return el;
    }

    displayImage(imgIndex) {
        let self = this;
        let el = this.getElement();
        let imgEntry = this.imgList[imgIndex];
        this.imgIndex = imgIndex;

        // Display loader
        let loadingEl = document.createElement('div');
        loadingEl.classList.add('mo-lb-screen');
        loadingEl.innerHTML = '<i></i>';
        let currentScreen = el.querySelector('.mo-lb-screen');
        currentScreen.parentElement.replaceChild(loadingEl, currentScreen);

        // Change title
        el.querySelector('.mo-lb-title h2').innerText = imgEntry.title;

        // Define display function
        let displayImg = function(img) {
            // Create new element
            let displayEl = document.createElement('a');
            displayEl.href = imgEntry.srcOriginal;
            displayEl.target = '_blank';
            displayEl.classList.add('mo-lb-screen');
            displayEl.appendChild(img);

            // Bind listeners
            displayEl.addEventListener('click', self.onDisplayClick.bind(self, displayEl));

            // Replace loading with screen
            let currentScreen = el.querySelector('.mo-lb-screen');
            currentScreen.parentElement.replaceChild(displayEl, currentScreen);
        };

        // If in image cache
        if(typeof this.imgCache[imgEntry.src] !== 'undefined') {
            displayImg(this.imgCache[imgEntry.src]);
        }
        // Otherwise load image
        else {
            let newImg = document.createElement('img');
            newImg.onload = function() {
                self.imgCache[imgEntry.src] = newImg;
                displayImg(this);
            };
            newImg.src = imgEntry.src;
        }
    }

    open(imgIndex) {
        document.body.appendChild(this.getElement());
        this.displayImage(imgIndex);
    }

    close() {
        document.body.removeChild(this.getElement());
    }

    next() {
        if(this.imgIndex + 1 > this.imgList.length - 1) {
            this.displayImage(0);
        } else {
            this.displayImage(this.imgIndex + 1);
        }
    }

    previous() {
        if(this.imgIndex - 1 < 0) {
            this.displayImage(this.imgList.length - 1);
        } else {
            this.displayImage(this.imgIndex - 1);
        }
    }

    onDisplayClick(displayEl, e) {
        if(e.target === displayEl.querySelector('img')) {
            return;
        }
        e.preventDefault();
        this.close();
    }

    getElement() {
        return this.element;
    }
};


class GallleryLightbox {
    static init() {
        let galleries = document.querySelectorAll('.js-lb')
        galleries.forEach(function(el) {
            let imgList = [];
            let galEntries = el.querySelectorAll('.js-lb-entry');
            for(let i = 0; i < galEntries.length; i += 1) {
                let galEntry = galEntries[i];
                imgList.push({
                    'title': galEntry.title,
                    'src': galEntry.dataset.gallerySrc,
                    'srcOriginal': galEntry.href
                });
            }
            let lightbox = new Lightbox(imgList);
            for(let i = 0; i < galEntries.length; i += 1) {
                galEntries[i].addEventListener('click', function(e) {
                    e.preventDefault();
                    lightbox.open(i);
                });
            }
        });
    }
};


export default Lightbox;
export {
    Lightbox,
    GallleryLightbox
}
